<app-ice-card>
  <section class="damage-reason-section">
    <div class="damage-reason-section-heading">3/3 Forsikring</div>
    <app-ice-alert type="warning" [iconName]="IconNames.ice_warning">
      <div heading>Telefonen har skader som må repareres.</div>
      <div>Dette dekker normalt forsikringen.</div>
    </app-ice-alert>
    <section class="insurance-info">
      <header>Ønsker kunden å bruke forsikringen?</header>
      <div class="insurance-info-details">
        <div>
          Siden telefonen har skader må den repareres for at ice skal kunne selge den videre. Kunde kan bare sende den inn,
          så fikser ice den. Kunde må bare betale egenandelen på forsikringen.
        </div>
        <div>
          Hvis kunde ikke ønsker å bruke forsikringen må telefonen repareres hos godkjent reparatør før den blir byttet inn.
        </div>
      </div>
    </section>
    @if (isLoadingDamageReasons || !form) {
      <app-spinner />
    } @else {
      <div class="form-wrapper" [formGroup]="form">
        <mat-checkbox disableRipple [formControl]="deductibleInfoControl">
          <span class="deductible-check-box">
            Ja, kunde ønsker å bruke forsikringen og er informert om egenandelen på {{ deductibleInfo.deductible }} kr som
            kommer på en senere faktura.
          </span>
        </mat-checkbox>
        <mat-form-field appearance="outline" class="form-field-width">
          <mat-label>Skadedato</mat-label>
          <input
            data-testid="damage-date-input"
            matInput
            [errorStateMatcher]="matcher"
            [formControl]="damageDateControl"
            [matDatepicker]="pickerFrom"
            [max]="today"
            [min]="minDate"
          />
          <mat-datepicker-toggle matSuffix [for]="pickerFrom" />
          <mat-datepicker #pickerFrom />
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field-width">
          <mat-label>Forklar kort hva som skjedde</mat-label>
          <input
            data-testid="damage-reason-input"
            matInput
            [errorStateMatcher]="matcher"
            [formControl]="damageReasonsTextControl"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="ice-custom-mat-select form-field-width">
          <mat-label>Velg årsak</mat-label>
          <mat-select [errorStateMatcher]="matcher" [formControl]="damageReasonsControl">
            @for (damageReason of damageReasons; track damageReason.code) {
              <mat-option [value]="damageReason.code">
                {{ damageReason.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-buttons">
        <app-ice-button
          color="secondary"
          testId="mobile-phone-insurance-back-button"
          (click)="navigateToPreviousStep.emit()"
        >
          Tilbake
        </app-ice-button>
        <app-ice-button
          color="primary"
          testId="submit-mobile-phone-insurance-button"
          [disabled]="form.invalid"
          [isLoading]="isCreatingClaim"
          (click)="onComplete()"
        >
          Ferdig
        </app-ice-button>
      </div>
    }
  </section>
</app-ice-card>
